import { L3_PATHS, staticRoutes } from 'Deer/constants/routes';
import { staticRoutesWithCustomSidebar } from 'Deer/constants/staticRoutesWithCustomSidebar';

import { routes as rabbitRoutes } from 'constants/routes';

import { RedirectConfig } from './useDeerRabbitRedirection';

const goalsDeerRabbitRoutesMap: Array<RedirectConfig> = [
  {
    deerRoute: L3_PATHS['my-data'].goal.myGoals,
    rabbitRoute:
      '/goals/audit?cohort=%7B"id"%3A-12%2C"name"%3A"My+Goals"%2C"type"%3A"MY_OKRs"%2C"teamId"%3A-12%7D&teamId=-12',
    routeType: 'LANDING_PAGE',
  },
  {
    deerRoute: L3_PATHS['my-data'].goal.myGoals,
    rabbitRoute: '/goals/list?cohort=%7B"id"%3A-12%2C"name"%3A"My+Goals"%2C"type"%3A"MY_OKRs"%7D&teamId=-12',
    routeType: 'LANDING_PAGE',
  },
  {
    deerRoute: L3_PATHS['my-data'].goal.myCompany,
    rabbitRoute: '/goals/audit?cohort=%7B"id"%3A-1%2C"name"%3A"My+Company"%2C"type"%3A"ALL_EMPLOYEE"%7D&teamId=-12',
    routeType: 'LANDING_PAGE',
  },
  {
    deerRoute: L3_PATHS.team.directReports.goal.manage,
    rabbitRoute: '/goals/list?cohort=%7B"id"%3A-2%2C"name"%3A"My+Team"%2C"type"%3A"MY_TEAM"%7D&teamId=-12',
    routeType: 'LANDING_PAGE',
  },
  {
    deerRoute: L3_PATHS.team.directReports.goal.manage,
    rabbitRoute: '/goals/insights?cohort=%7B"id"%3A-2%2C"name"%3A"My+Team"%2C"type"%3A"MY_TEAM"%7D',
    routeType: 'LANDING_PAGE',
  },
  {
    deerRoute: L3_PATHS.team.allReports.goal.manage,
    rabbitRoute:
      '/goals/list?cohort=%7B"id"%3A-3%2C"name"%3A"My+Organization+Tree"%2C"type"%3A"MY_ORGANIZATION"%7D&teamId=-12',
    routeType: 'LANDING_PAGE',
  },
  {
    deerRoute: L3_PATHS.team.allReports.goal.manage,
    rabbitRoute:
      '/goals/insights?cohort=%7B"id"%3A-3%2C"name"%3A"My+Organization+Tree"%2C"type"%3A"MY_ORGANIZATION"%7D',
    routeType: 'LANDING_PAGE',
  },
  {
    deerRoute: L3_PATHS.company.goal.manage,
    rabbitRoute: '/goals/audit?cohort=%7B"id"%3A-1%2C"name"%3A"My+Company"%2C"type"%3A"ALL_EMPLOYEE"%7D&teamId=-12',
    routeType: 'LANDING_PAGE',
  },
  {
    deerRoute: L3_PATHS.company.goal.settings,
    rabbitRoute: '/moduleSettings?module=goal',
    routeType: 'MODULE_SETTINGS',
  },
  {
    deerRoute: L3_PATHS['my-data'].goal.myGoals,
    rabbitRoute: `/goals/list?ids=\${id}&showTaskDetails=\${showTaskDetail}s&type=\${type}`,
    routeType: 'CUSTOM_PARAMS',
  },
  {
    deerRoute: L3_PATHS['my-data'].goal.myGoals,
    rabbitRoute: '/goals',
    routeType: 'LANDING_PAGE',
  },
  {
    deerRoute: staticRoutes['my-data']['my-settings'].knowledgeHub,
    rabbitRoute: '/settings/knowledge-hub',
    routeType: 'LANDING_PAGE',
  },
];

const initiativesDeerRabbitRoutesMap: Array<RedirectConfig> = [
  {
    deerRoute: L3_PATHS['my-data'].initiative.myInitiatives,
    rabbitRoute:
      '/initiative/audit?cohort=%7B"id"%3A-11%2C"name"%3A"My+Initiatives"%2C"type"%3A"MY_INITIATIVES"%2C"teamId"%3A-11%7D',
    routeType: 'LANDING_PAGE',
  },
];

const oneOnOneDeerRabbitRoutesMap: Array<RedirectConfig> = [
  {
    deerRoute: L3_PATHS['my-data'].oneOnOne.myOneOnOne,
    rabbitRoute: '/oneOnOne/audit?cohort=%7B"id"%3A-9%2C"name"%3A"My+1%3A1s"%2C"type"%3A"MY_ONE_ON_ONE"%7D',
    routeType: 'LANDING_PAGE',
  },
  {
    deerRoute: L3_PATHS['my-data'].oneOnOne.myOneOnOne,
    rabbitRoute: '/oneOnOne/audit',
    routeType: 'LANDING_PAGE',
  },
  {
    deerRoute: L3_PATHS.team.allReports.oneOnOne.manage,
    rabbitRoute:
      '/oneOnOne/insights?cohort=%7B"id"%3A-3%2C"name"%3A"My+Organization+Tree"%2C"type"%3A"MY_ORGANIZATION"%7D',
    routeType: 'LANDING_PAGE',
  },
  {
    deerRoute: L3_PATHS.team.allReports.oneOnOne.insights,
    rabbitRoute:
      '/oneOnOne/insights?cohort=%7B"id"%3A-3%2C"name"%3A"My+Organization+Tree"%2C"type"%3A"MY_ORGANIZATION"%7D',
    routeType: 'LANDING_PAGE',
  },
  {
    deerRoute: L3_PATHS.company.oneOnOne.insights,
    rabbitRoute: '/oneOnOne/insights?cohort=%7B"id"%3A-1%2C"name"%3A"My+Company"%2C"type"%3A"ALL_EMPLOYEE"%7D',
    routeType: 'LANDING_PAGE',
  },
  {
    deerRoute: L3_PATHS.company.oneOnOne.settings,
    rabbitRoute: '/moduleSettings?module=oneOnOne',
    routeType: 'MODULE_SETTINGS',
  },
  {
    deerRoute: staticRoutes['my-data']['my-settings'].calendar,
    rabbitRoute: '/moduleSettings?module=oneOnOne&activeTabId=calendar',
    routeType: 'MODULE_SETTINGS',
  },
  {
    deerRoute: L3_PATHS['my-data'].oneOnOne.myOneOnOne,
    rabbitRoute: '/oneOnOne',
    routeType: 'LANDING_PAGE',
  },
  {
    deerRoute: L3_PATHS['my-data'].oneOnOne.masterPage,
    rabbitRoute: '/oneOnOne/:masterId',
    routeType: 'CUSTOM_PARAMS',
  },
  {
    deerRoute: L3_PATHS['my-data'].oneOnOne.legacyPage,
    rabbitRoute: '/oneOnOne/legacy/id/:instanceId',
    routeType: 'CUSTOM_PARAMS',
  },
];

const feedbackDeerRabbitRoutesMap: Array<RedirectConfig> = [
  {
    deerRoute: L3_PATHS['my-data'].develop.feedback,
    rabbitRoute: '/feedback',
    routeType: 'LANDING_PAGE',
  },
  {
    deerRoute: L3_PATHS.team.directReports.develop.insights,
    rabbitRoute: '/analytics/feedback?cohort=%7B"id"%3A-2%2C"name"%3A"My+Team"%2C"type"%3A"MY_TEAM"%7D',
    routeType: 'LANDING_PAGE',
  },
  {
    deerRoute: L3_PATHS.team.allReports.develop.insights,
    rabbitRoute:
      '/analytics/feedback?cohort=%7B"id"%3A-3%2C"name"%3A"My+Organization+Tree"%2C"type"%3A"MY_ORGANIZATION"%7D',
    routeType: 'LANDING_PAGE',
  },
  {
    deerRoute: L3_PATHS.company.develop.insights,
    rabbitRoute: '/analytics/feedback?cohort=%7B"id"%3A-1%2C"name"%3A"My+Company"%2C"type"%3A"ALL_EMPLOYEE"%7D',
    routeType: 'LANDING_PAGE',
  },
  {
    // this is a special type of route because in rabbit it's a normal route /settings/competencies but in deer it has MODULE_SETTINGS tab type
    deerRoute: `${L3_PATHS.company.develop.settings}?activeTabId=competency_library`,
    rabbitRoute: '/settings/competencies',
    routeType: 'LANDING_PAGE',
  },
  {
    deerRoute: L3_PATHS['my-data'].develop.feedback,
    rabbitRoute: `/feedback?formType=\${formType}&feedbackId=\${feedbackId}&showFeedback=\${showFeedback}`,
    routeType: 'CUSTOM_PARAMS',
  },
];

const reviewDeerRabbitRoutesMap: Array<RedirectConfig> = [
  {
    deerRoute: L3_PATHS['my-data'].review.myReviews,
    rabbitRoute: '/review/audit?activeTableId=PENDING_ON_ME&reviewCycleId=null',
    routeType: 'LANDING_PAGE',
  },
  {
    deerRoute: L3_PATHS.team.directReports.review.manage,
    rabbitRoute: '/review/manage?type=MY_TEAM',
    routeType: 'LANDING_PAGE',
  },
  {
    deerRoute: L3_PATHS.team.directReports.review.manage,
    rabbitRoute: '/review/manage?cohort=%7B"id"%3A-2%2C"name"%3A"My+Team"%2C"type"%3A"MY_TEAM"%7D',
    routeType: 'LANDING_PAGE',
  },
  {
    deerRoute: L3_PATHS.team.allReports.review.manage,
    rabbitRoute: '/review/manage?cohort=%7B"id"%3A-3%2C"name"%3A"My+Organization+Tree"%2C"type"%3A"MY_ORGANIZATION"%7D',
    routeType: 'LANDING_PAGE',
  },
  {
    deerRoute: L3_PATHS.company.review.manage,
    rabbitRoute: '/review/manage?cohort=%7B"id"%3A-1%2C"name"%3A"My+Company"%2C"type"%3A"ALL_EMPLOYEE"%7D',
    routeType: 'LANDING_PAGE',
  },
  {
    deerRoute: L3_PATHS.company.review.settings,
    rabbitRoute: '/moduleSettings?module=status',
    routeType: 'MODULE_SETTINGS',
  },
  {
    deerRoute: L3_PATHS['my-data'].review.myReviews,
    rabbitRoute: '/review',
    routeType: 'LANDING_PAGE',
  },
];

const engagementDeerRabbitRoutesMap: Array<RedirectConfig> = [
  {
    deerRoute: L3_PATHS['my-data'].engagement.mySurveys,
    rabbitRoute: '/engagement',
    routeType: 'LANDING_PAGE',
  },
  {
    deerRoute: L3_PATHS.team.directReports.engagement.insights,
    rabbitRoute: '/engagement/insights?type=MY_TEAM',
    routeType: 'LANDING_PAGE',
  },
];

const disciplinaryActionsDeerRabbitRoutesMap: Array<RedirectConfig> = [
  {
    deerRoute: L3_PATHS['my-data'].disciplinaryActions.pendingDisciplinaryActions,
    rabbitRoute: '/disciplinary-actions/employee/pending-disciplinary-actions',
    routeType: 'LANDING_PAGE',
  },
  {
    deerRoute: L3_PATHS['my-data'].disciplinaryActions.allDisciplinaryActions,
    rabbitRoute: '/disciplinary-actions/employee/all-disciplinary-actions',
    routeType: 'LANDING_PAGE',
  },
  {
    deerRoute: L3_PATHS.team.allReports.disciplinaryActions.pendingDisciplinaryActions,
    rabbitRoute: '/disciplinary-actions/manager/pending-disciplinary-actions',
    routeType: 'LANDING_PAGE',
  },
  {
    deerRoute: L3_PATHS.team.allReports.disciplinaryActions.allDisciplinaryActions,
    rabbitRoute: '/disciplinary-actions/manager/all-disciplinary-actions',
    routeType: 'LANDING_PAGE',
  },
  {
    deerRoute: L3_PATHS.team.directReports.disciplinaryActions.pendingDisciplinaryActions,
    rabbitRoute: '/disciplinary-actions/manager/pending-disciplinary-actions',
    routeType: 'LANDING_PAGE',
  },
  {
    deerRoute: L3_PATHS.team.directReports.disciplinaryActions.allDisciplinaryActions,
    rabbitRoute: '/disciplinary-actions/manager/all-disciplinary-actions',
    routeType: 'LANDING_PAGE',
  },
];

const settingsDeerRabbitRoutesMap: Array<RedirectConfig> = [
  {
    deerRoute: staticRoutes.company.settings.platform.organization,
    rabbitRoute: '/settings/company',
    routeType: 'PLATFORM_SETTINGS',
  },
  {
    deerRoute: staticRoutes.company.settings.platform.employees,
    rabbitRoute: '/settings/employees',
    routeType: 'PLATFORM_SETTINGS',
  },
  {
    deerRoute: staticRoutes.company.settings.platform['function-grade'],
    rabbitRoute: '/settings/function-grade',
    routeType: 'PLATFORM_SETTINGS',
  },
  {
    deerRoute: staticRoutes.company.settings.platform.access,
    rabbitRoute: '/settings/customAccess',
    routeType: 'PLATFORM_SETTINGS',
  },
  {
    deerRoute: staticRoutes.company.settings.plugins.hris,
    rabbitRoute: '/settings/plugins/hris',
    routeType: 'PLATFORM_SETTINGS',
  },
  {
    deerRoute: staticRoutes.company.settings.plugins.jira,
    rabbitRoute: '/settings/plugins/jira',
    routeType: 'PLATFORM_SETTINGS',
  },
  {
    deerRoute: staticRoutes.company.settings.plugins.msteams,
    rabbitRoute: '/settings/plugins/msTeams',
    routeType: 'PLATFORM_SETTINGS',
  },
  {
    deerRoute: staticRoutes.company.settings.plugins.salesforce,
    rabbitRoute: '/settings/plugins/salesforce',
    routeType: 'PLATFORM_SETTINGS',
  },
  {
    deerRoute: staticRoutes.company.settings.plugins.slack,
    rabbitRoute: '/settings/plugins/slack',
    routeType: 'PLATFORM_SETTINGS',
  },
  {
    deerRoute: staticRoutes['my-data']['my-settings'].notifications,
    rabbitRoute: '/settings/notifications',
    routeType: 'PLATFORM_SETTINGS',
  },
];

// routes which are same as rabbit with just /app prefix and params to be copied from rabbit to deer
const prefixRoutesMap: Array<RedirectConfig> = [
  {
    deerRoute: staticRoutesWithCustomSidebar.reviewsFormFilling,
    rabbitRoute: rabbitRoutes.performanceReview.forms,
    routeType: 'CUSTOM_PARAMS',
  },
  {
    deerRoute: staticRoutesWithCustomSidebar.reviewsResultPage,
    rabbitRoute: rabbitRoutes.performanceReview.result,
    routeType: 'CUSTOM_PARAMS',
  },
  {
    deerRoute: staticRoutesWithCustomSidebar.reviewCycleCreation,
    rabbitRoute: rabbitRoutes.settings.review.reviewCycle,
    routeType: 'CUSTOM_PARAMS',
  },
  {
    deerRoute: staticRoutesWithCustomSidebar.reviewCycleTemplateCreation,
    rabbitRoute: rabbitRoutes.template.review.index,
    routeType: 'CUSTOM_PARAMS',
  },
  {
    deerRoute: staticRoutesWithCustomSidebar.reviewCycleTemplatePreview,
    rabbitRoute: rabbitRoutes.template.review.preview,
    routeType: 'CUSTOM_PARAMS',
  },
  {
    deerRoute: staticRoutesWithCustomSidebar.engagementSurveyCreation,
    rabbitRoute: rabbitRoutes.settings.engagement.pulseKickstart,
    routeType: 'CUSTOM_PARAMS',
  },
  {
    deerRoute: staticRoutesWithCustomSidebar.engagementTemplateCreation,
    rabbitRoute: rabbitRoutes.template.engagement.index,
    routeType: 'CUSTOM_PARAMS',
  },
  {
    deerRoute: staticRoutesWithCustomSidebar.engagementTemplatePreview,
    rabbitRoute: rabbitRoutes.template.engagement.preview,
    routeType: 'CUSTOM_PARAMS',
  },
  {
    deerRoute: staticRoutes.profile,
    rabbitRoute: rabbitRoutes.profile,
    routeType: 'CUSTOM_PARAMS',
  },
  {
    deerRoute: L3_PATHS['my-data'].oneOnOne.instancePage,
    rabbitRoute: rabbitRoutes.oneOnOne.instanceRabbit,
    routeType: 'CUSTOM_PARAMS',
  },
];

export const deerRabbitRoutesMap = [
  ...goalsDeerRabbitRoutesMap,
  ...initiativesDeerRabbitRoutesMap,
  ...oneOnOneDeerRabbitRoutesMap,
  ...feedbackDeerRabbitRoutesMap,
  ...reviewDeerRabbitRoutesMap,
  ...engagementDeerRabbitRoutesMap,
  ...settingsDeerRabbitRoutesMap,
  ...prefixRoutesMap,
  ...disciplinaryActionsDeerRabbitRoutesMap,
];
